import React from 'react';
import Grid from '@mui/material/Grid';
import { ScenarioType } from 'shared/enums/scenario-type';

import OrganisationUnitScenario from 'features/residents/models/organisation-unit-scenario';
import OrganizationUnitScenarioIcon from 'features/residents/resident-settings/components/organization-unit-scenario-icon/organization-unit-scenario-icon';

type Props = {
  organizationUnitScenarios: OrganisationUnitScenario[];
};

const AlarmScenariosColumn = ({ organizationUnitScenarios }: Readonly<Props>): React.JSX.Element => {
  const isMatchingScenarioType = (scenarioType: ScenarioType) => organizationUnitScenarios.some((s) => s.scenarioType === scenarioType);

  const organizationUnitScenarioIsActive = (scenarioType: ScenarioType) =>
    organizationUnitScenarios.find((s) => s.scenarioType === scenarioType)?.isActive ?? false;

  const iconStyle = { fontSize: 16 };

  return (
    <Grid container gap={1.5}>
      <Grid>
        <OrganizationUnitScenarioIcon.BedIcon
          sx={iconStyle}
          isActive={organizationUnitScenarioIsActive(ScenarioType.Bed)}
          isVisible={isMatchingScenarioType(ScenarioType.Bed)}
        />
      </Grid>
      <Grid>
        <OrganizationUnitScenarioIcon.RoomIcon
          sx={iconStyle}
          isActive={organizationUnitScenarioIsActive(ScenarioType.Room)}
          isVisible={isMatchingScenarioType(ScenarioType.Room)}
        />
      </Grid>
      <Grid>
        <OrganizationUnitScenarioIcon.BathroomIcon
          sx={iconStyle}
          isActive={organizationUnitScenarioIsActive(ScenarioType.Bathroom)}
          isVisible={isMatchingScenarioType(ScenarioType.Bathroom)}
        />
      </Grid>
      <Grid>
        <OrganizationUnitScenarioIcon.IntruderIcon
          sx={iconStyle}
          isActive={organizationUnitScenarioIsActive(ScenarioType.Intruder)}
          isVisible={isMatchingScenarioType(ScenarioType.Intruder)}
        />
      </Grid>
      <Grid>
        <OrganizationUnitScenarioIcon.FallDetectionIcon
          sx={iconStyle}
          isActive={organizationUnitScenarioIsActive(ScenarioType.FallDetection)}
          isVisible={isMatchingScenarioType(ScenarioType.FallDetection)}
        />
      </Grid>
      <Grid>
        <OrganizationUnitScenarioIcon.DoorIcon
          sx={iconStyle}
          isActive={organizationUnitScenarioIsActive(ScenarioType.Door)}
          isVisible={isMatchingScenarioType(ScenarioType.Door)}
        />
      </Grid>
      <Grid>
        <OrganizationUnitScenarioIcon.AudioIcon
          sx={iconStyle}
          isActive={organizationUnitScenarioIsActive(ScenarioType.Audio)}
          isVisible={isMatchingScenarioType(ScenarioType.Audio)}
        />
      </Grid>
      <Grid>
        <OrganizationUnitScenarioIcon.VideoIcon
          sx={iconStyle}
          isActive={organizationUnitScenarioIsActive(ScenarioType.Video)}
          isVisible={isMatchingScenarioType(ScenarioType.Video)}
        />
      </Grid>
      <Grid>
        <OrganizationUnitScenarioIcon.AcousticIcon
          sx={iconStyle}
          isActive={organizationUnitScenarioIsActive(ScenarioType.Acoustic)}
          isVisible={isMatchingScenarioType(ScenarioType.Acoustic)}
        />
      </Grid>
      <Grid>
        <OrganizationUnitScenarioIcon.WanderingDetectionIcon
          sx={iconStyle}
          isActive={organizationUnitScenarioIsActive(ScenarioType.WanderingDetection)}
          isVisible={isMatchingScenarioType(ScenarioType.WanderingDetection)}
        />
      </Grid>
      <Grid>
        <OrganizationUnitScenarioIcon.CurrentLocationIcon
          sx={iconStyle}
          isActive={organizationUnitScenarioIsActive(ScenarioType.CurrentLocation)}
          isVisible={isMatchingScenarioType(ScenarioType.CurrentLocation)}
        />
      </Grid>
    </Grid>
  );
};

export default AlarmScenariosColumn;
